var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.remontar)?_c(_vm.$mapaTelas(_vm.tela.tipo),{tag:"component",attrs:{"servicoAtendimento":_vm.servicoAtendimento},on:{"voltar":_vm.voltar,"cancelar":_vm.cancelar,"processar":_vm.processar}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }